module.exports = new __parcel__URL__("map-marker-roof-unselected.a88d23e2.svg").toString();